module.exports = __webpack_public_path__ + "imgs/leafwell2.a81133da402fb9816b627ba62bbe1848.svg";